<template>
  <transition name="collapse" @leave="leave">
    <slot></slot>
  </transition>
</template>

<script>
export default {
  name: 'CollapseTransition',
  methods: {
    leave (element) {
      element.style['max-height'] = getComputedStyle(element).height

      requestAnimationFrame(() => {
        element.style['max-height'] = 0
      })
    }
  }
}
</script>

<style scoped>
.collapse-enter-active, .collapse-leave-active {
  transition: max-height .2s;
}
.collapse-enter, .collapse-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
